import { render, staticRenderFns } from "./HolidayFormDialog.vue?vue&type=template&id=160370a4&"
import script from "./HolidayFormDialog.vue?vue&type=script&lang=js&"
export * from "./HolidayFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports